module.exports = __webpack_public_path__ + "assets/img/upload.1c37d068.svg";